import React from 'react'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import formModel from 'containers/Onboarding/FormModels/Models';
import { useFormikContext } from 'formik'
import dataStorage from 'dataStorage';
import {
    MultipleSelectField
} from 'components/CustomFields'
import {
    ACCOUNT_TYPE_OPTIONS
} from 'constants/Options/options'

const { formField } = formModel

const AccountType = () => {
    const { values } = useFormikContext();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <MultipleSelectField
                    name={formField.account_type.name}
                    label={formField.account_type.label}
                    data={ACCOUNT_TYPE_OPTIONS}
                    fullWidth
                />
            </Grid>
        </Grid>
    )
}

export default AccountType